export * from './show';

import { Order } from '~/@types/table/order';
import { apiClient } from '~/api/client';
import { AgentLoanOfficerCompanies } from '~/sections/agents/profile/types';

type IndexParams = {
  id: string;
  page: number;
  sort_field: string;
  order: Order;
  period: Period;
  export_team_data: boolean;
};

type IndexResponse = {
  data: AgentLoanOfficerCompanies;
};

export const index = async ({ id, sort_field, order, ...restParams }: IndexParams) =>
  apiClient.get<IndexResponse>(
    `/realtors/${id}/loan_officer_companies?sort[field]=${sort_field}&sort[order]=${order}`,
    { params: restParams }
  );
